/** @format */
import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { Milliseconds } from '@toucan/client/global/application';
import { MarketCode } from '@toucan/client/global/market';

import { getSimilarModelRecommendations } from '@toucan/client/core/recommendations';

export const useSimilarModelRecommendations = (
    modelIds: number[],
    market: MarketCode,
    options: Pick<UseQueryOptions, 'enabled'> = { enabled: true }
) => {
    return useQuery({
        queryKey: ['similar-model-recommendations', ...modelIds],
        enabled: options.enabled && Boolean(modelIds.length),
        queryFn: () => getSimilarModelRecommendations(modelIds, market),
        staleTime: Milliseconds.ONE_HOUR,
    });
};
